import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";

export function formatCounterpartyContactName(
    contact: Pick<
        CounterpartyContact,
        "title" | "firstName" | "middleName" | "lastName" | "suffix"
    >,
): string {
    return [
        contact.title,
        contact.firstName,
        contact.middleName,
        contact.lastName,
        contact.suffix,
    ]
        .filter(Boolean)
        .join(" ");
}

function firstPresent(
    ...values: Array<string | null | undefined>
): string | undefined {
    return values.find((value): value is string => Boolean(value));
}

export function formatCounterpartyContactHeadline(
    contact: CounterpartyContact,
): string {
    return (
        firstPresent(
            formatCounterpartyContactName(contact),
            contact.email,
            contact.phoneNumber,
            contact.label,
        ) ?? "Contact"
    );
}

export function formatCounterpartyAddressLines(
    address: CounterpartyAddress,
): string[] {
    const street = [address.street, address.street2].filter(Boolean).join(", ");
    const locality = [address.city, address.state, address.postalCode]
        .filter(Boolean)
        .join(", ");
    return [street, locality, address.country].filter((line): line is string =>
        Boolean(line),
    );
}

export function formatCounterpartyAddressHeadline(
    address: CounterpartyAddress,
): string {
    return (
        firstPresent(
            formatCounterpartyAddressLines(address)[0],
            address.label,
        ) ?? "Address"
    );
}

export function formatCounterpartyAddressSummary(
    address: CounterpartyAddress,
): string {
    return (
        firstPresent(
            formatCounterpartyAddressLines(address).join(" · "),
            address.label,
        ) ?? "Address"
    );
}
